import { useQuery } from '@tanstack/react-query';
import { upcomingRecurringSessions } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';


export const useRecurringListQuery = (seriesId: string, limit = 5, opts?: BaseQueryOpts) => {
  const { data, isInitialLoading: isLoading } = useQuery({
    queryKey: [ 'recurringList', seriesId, limit ],
    queryFn: async () => {
      const response = await upcomingRecurringSessions({ series_id: seriesId, limit: limit });

      return response.data;
    },
    ...opts
  });

  return { data, isLoading };
};
